module.exports = __webpack_public_path__ + "static/img/increase.d0b8211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/increase.png
// module id = wkJU
// module chunks = 1